import { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { apiFetch } from './apiUtils';

export type DncPreviewAccess = 'loading' | 'allowed' | 'denied';

export function useDncPreviewAccess(): DncPreviewAccess {
  const { token, activeContext } = useAuth();
  const [access, setAccess] = useState<DncPreviewAccess>('loading');

  useEffect(() => {
    if (import.meta.env.VITE_DNC_COMPLIANCE_ENABLED !== 'true' || !token) {
      setAccess('denied');
      return;
    }

    let cancelled = false;
    setAccess('loading');
    apiFetch('/api/leads-contacts/compliance/access', {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(activeContext?.id ? { 'X-Active-Context': activeContext.id } : {}),
      },
    })
      .then((response) => {
        if (!cancelled) setAccess(response.ok ? 'allowed' : 'denied');
      })
      .catch(() => {
        if (!cancelled) setAccess('denied');
      });

    return () => { cancelled = true; };
  }, [token, activeContext?.id]);

  return access;
}